import { translate as t } from '@thoughtspot/i18n';
import { getErrorObjectFromGraphQLErrors } from "../../../utils/error-handling/error-utils";
import { TranslationKeys } from '../constant';
export var ValidationErrorKey;
(function (ValidationErrorKey) {
    ValidationErrorKey[ValidationErrorKey["REPOSITORY"] = 0] = "REPOSITORY";
    ValidationErrorKey[ValidationErrorKey["USERNAME"] = 1] = "USERNAME";
    ValidationErrorKey[ValidationErrorKey["TOKEN"] = 2] = "TOKEN";
})(ValidationErrorKey || (ValidationErrorKey = {}));
export var ConfigFormFieldLabels;
(function (ConfigFormFieldLabels) {
    ConfigFormFieldLabels["REPOSITORY"] = "repository";
    ConfigFormFieldLabels["USERNAME"] = "username";
    ConfigFormFieldLabels["TOKEN"] = "token";
})(ConfigFormFieldLabels || (ConfigFormFieldLabels = {}));
export const testIds = {
    repository: 'version-control-form-repository-input',
    username: 'version-control-form-username-input',
    token: 'version-control-form-token-input',
    branch: 'version-control-form-branch-select',
    guidBranch: 'version-control-form-guid-branch',
    enableVersionHistory: 'version-control-form-save-version-history-checkbox',
};
export const errorMessageMap = {
    [ValidationErrorKey.REPOSITORY]: t(TranslationKeys.VCS_ADMIN_CONFIG_REPO_FIELD_REQUIRED),
    [ValidationErrorKey.USERNAME]: t(TranslationKeys.VCS_ADMIN_CONFIG_USERNAME_REQUIRED),
    [ValidationErrorKey.TOKEN]: t(TranslationKeys.VCS_ADMIN_CONFIG_TOKEN_REQUIRED),
};
export var DefaultConfigBranch;
(function (DefaultConfigBranch) {
    DefaultConfigBranch["TS_CONFIG_FILE"] = "ts_config_files";
})(DefaultConfigBranch || (DefaultConfigBranch = {}));
export const validateConfigForm = (configForm, isEditModal, oldConfigDetails) => {
    const errorMap = {};
    if (!configForm?.repository?.trim()) {
        errorMap[ValidationErrorKey.REPOSITORY] = true;
    }
    if (!configForm?.username?.trim()) {
        errorMap[ValidationErrorKey.USERNAME] = true;
    }
    if (!isEditModal && !configForm?.token?.trim()) {
        errorMap[ValidationErrorKey.TOKEN] = true;
    }
    if (isEditModal &&
        (oldConfigDetails?.repository_url !== configForm?.repository?.trim() ||
            oldConfigDetails?.username !== configForm?.username?.trim()) &&
        !configForm?.token?.trim()) {
        errorMap[ValidationErrorKey.TOKEN] = true;
    }
    return errorMap;
};
export const formatBranchList = (branchMap, withDisabled) => {
    const branches = Object.keys(branchMap);
    const options = branches.map(branch => ({
        id: branch,
        label: branch,
        disabled: withDisabled ? branchMap[branch] : false,
    }));
    return [
        {
            options,
        },
    ];
};
export const getErrorMessage = (error) => {
    const errorObjects = getErrorObjectFromGraphQLErrors(error);
    const errorCode = errorObjects?.[0]?.errorObj?.extensions?.exception?.upstreamResponse?.data?.error?.message?.code?.toString();
    if (errorCode === '15003') {
        return {
            message: t(TranslationKeys.VCS_ADMIN_CONFIG_MODAL_INVALID_CREDENTIALS),
            errorCd: errorCode,
        };
    }
    if (errorCode === '15002') {
        return {
            message: t(TranslationKeys.VCS_ADMIN_CREATE_CONFIG_FAILURE_MESSAGE),
            errorCd: errorCode,
        };
    }
    if (errorCode === '15030') {
        const debug = errorObjects[0]?.errorObj?.extensions?.exception?.upstreamResponse
            ?.data?.error?.message?.debug;
        return {
            message: debug
                ? JSON.parse(debug)
                : t(TranslationKeys.VCS_SOMETHING_WENT_WRONG_ERROR),
            errorCd: errorCode,
        };
    }
    return {
        message: t(TranslationKeys.VCS_SOMETHING_WENT_WRONG_ERROR),
        errorCd: '-1',
    };
};
export const getErrorList = (error) => {
    const errorObjects = getErrorObjectFromGraphQLErrors(error);
    const debug = errorObjects?.[0]?.errorObj?.extensions?.exception?.upstreamResponse
        ?.data?.error?.message?.debug;
    const jsonDebugArray = debug ? JSON.parse(debug) : [];
    const errorList = jsonDebugArray.length
        ? JSON.parse(jsonDebugArray[0])?.map((jsonString) => JSON.parse(jsonString))
        : [];
    return errorList;
};
export const sanitizeConfigForm = (configForm) => {
    const { repository, username, token } = configForm;
    return {
        ...configForm,
        repository: repository?.trim(),
        username: username?.trim(),
        token: token?.trim(),
    };
};
//# sourceMappingURL=configuration-modal.util.js.map